/**
 * @file    pages/utils.css -  CSS utility classes
 * @author  Severn Lortie <severn@distributive.network>
 * @date    February 2024
 */
@media only screen and (max-width: 480px) {
  .xs-hidden {
    display: none !important;
  }
}

.font-monospace {
  font-family: "Berkeley", Courier, monospace;
}
